module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "lv-toggle",
    class: {
      'on': _vm.value
    },
    attrs: {
      "role": "switch",
      "aria-checked": String(_vm.value)
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    staticClass: "lv-thumb"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb39321a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forms/LvToggle.vue
// module id = 1762
// module chunks = 2